import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

export const VendorRowSkeleton = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      padding: '24px 16px 16px 16px',
      justifyContent: 'space-between',
    }}
  >
    <div style={{ display: 'flex', gap: 12 }}>
      <div style={{ paddingRight: 12 }}>
        <Skeleton
          borderRadiusSize="large"
          height="shape-size-action-14"
          width="shape-size-action-14"
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton borderRadiusSize="large" width="48.25" />
        <Skeleton borderRadiusSize="large" width="34.25" />
      </div>
    </div>

    <Skeleton
      borderRadiusSize="large"
      height="shape-size-action-05"
      width="shape-size-action-08"
    />
  </div>
);
